/**
 * @file CustomerNotesPanel.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-21
 * @modified 2026-09-21
 * @description What we already know about this customer, shown beside whatever
 *              someone is about to type: their contact notes, and the largest
 *              vehicle that can reach them.
 *
 *              Read-only on purpose. The notes belong to the contact record and
 *              are edited there — this is simply the place they are most likely
 *              to change what gets written next to them. A driver instruction
 *              typed without knowing an artic cannot get down the lane is the
 *              failure this is here to prevent, which is why the vehicle access
 *              travels with the notes rather than living on its own screen.
 *
 *              Extracted from Create Customer Order when Create Invoice and
 *              Create Haulage Job needed the same block. A third hand-rolled
 *              copy is a third place for the two to drift apart, and the rule
 *              this implements — vehicle access appears wherever notes do — is
 *              exactly the kind that rots when it lives in three files.
 */

import React from 'react';
import './CustomerNotesPanel.css';

/**
 * @param {string?} notes                 The contact's own notes.
 * @param {string?} largestVehicleAccess  Biggest lorry that can reach them.
 * @param {string}  label                 Heading above the box.
 * @param {string}  emptyText             Shown when there are no notes.
 */
function CustomerNotesPanel({
  notes,
  largestVehicleAccess,
  label = 'Customer Notes',
  emptyText = 'No notes on this customer.'
}) {
  return (
    <div className="customer-notes-panel">
      <label>{label}</label>
      <div className="customer-notes" title="From the customer's contact record — edit them there">
        {notes && String(notes).trim()
          ? notes
          : <span className="customer-notes-empty">{emptyText}</span>}
        {/* What will get down the lane, from the same record. Internal. */}
        <div className="customer-lva">
          <span className="customer-lva-label">Largest vehicle access</span>
          <span>
            {largestVehicleAccess && String(largestVehicleAccess).trim()
              ? largestVehicleAccess
              : <span className="customer-notes-empty">Not recorded</span>}
          </span>
        </div>
      </div>
    </div>
  );
}

export default CustomerNotesPanel;
